import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const hoursNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Hours,
  route: RoutesEnum.Hours,
  icon: 'schedule',
};
